<template>
  <div class="mt-15 rounded-15 bg-lightblue bg-opacity-50 p-15">
    <div class="text-13 font-bold line-height-22">
      课程资料下载：
    </div>
    <div
      v-for="(item, index) in list"
      :key="index"
      :class="index === 0 ? 'mt-15' : 'mt-20'"
      class="flex items-center justify-between"
    >
      <div class="flex flex-grow items-center">
        <van-icon name="todo-list" color="#F76745" size="28" />
        <div class="flex-grow pr-15 ml-15">
          <div class="break-all text-13 font-bold line-height-22 line-2">
            {{ item.name }}
          </div>
          <div class="mt-2 text-8 text-gray">
            {{ getfilesize(item.size) }}
          </div>
        </div>
      </div>
      <div class="square-30 flex flex-center">
        <van-loading
          v-if="item.loading"
          size="20px"
        />
        <img
          v-else
          src="/img/download.png"
          class="h-13 w-17 cursor-pointer"
          @click="downloadFile(item, item.url, item.name)"
        >
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
export default {
  name: 'DownloadList',
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  mounted () {
    this.list.forEach((s) => {
      s.loading = false
    })
  },
  methods: {
    // | 文件size转换文件大小
    getfilesize (size) {
      if (!size) { return '0B' }
      const num = 1024.00 // byte
      if (size < num) { return `${size}B` }
      if (size < num ** 2) { return `${(size / num).toFixed(2)}KB` } // kb
      if (size < num ** 3) { return `${(size / num ** 2).toFixed(2)}M` } // M
      if (size < num ** 4) { return `${(size / num ** 3).toFixed(2)}G` } // G
      return `${(size / num ** 4).toFixed(2)}T` // T
    },
    // | 下载文件
    async downloadFile (item, url, filename) {
      item.loading = true
      // 判断url是否可以正常下载
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        const a = document.createElement('a')
        a.href = url
        a.download = filename
        a.click()
        await this.$tkHelper.sleep(500)
        item.loading = false
        return
      }
      await this.$tkAjax.get(url).catch((e) => {
        Toast({
          message: '尝试访问该链接失败，暂时无法下载',
          position: 'bottom',
        })
        item.loading = false
        throw e
      })
      const element = document.createElement('a')
      element.setAttribute('href', url)
      element.setAttribute('download', filename)
      element.style.display = 'none'
      document.body.appendChild(element)
      element.click()
      document.body.removeChild(element)
      await this.$tkHelper.sleep(500)
      item.loading = false
    }
  }
}
</script>

<style scoped lang="scss">
</style>
